import { EventEmitter, Injectable, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { LoginRequest } from '../models/request/login.request';
import { BaseResponse } from '../models/response/BaseResponse';
import { HttpService } from './http.service';
import {User} from '../models/User';

@Injectable({
  providedIn: 'root'
})
export class AuthService extends HttpService{

  @Output() userlogin = new EventEmitter<User>();
  private readonly tokenStorageKey = 'token';
  private readonly userStorageKey = 'user';

  isUserLogged(): boolean{
    return this.getToken() !== '';
  }

  login(username: string, password: string): Observable<BaseResponse<User>>{
    return this.post('login', new LoginRequest(username, password));
  }

  storeSession(user: User): boolean {
    const token = user.jwt?.trim() ?? '';

    if (!token) {
      this.clearSession();
      return false;
    }

    localStorage.setItem(this.tokenStorageKey, token);
    localStorage.setItem(this.userStorageKey, JSON.stringify(user));

    return true;
  }

  logout(): void{
    const request = this.get('logout');

    this.clearSession();
    request.subscribe({ error: () => undefined });
  }

  clearSession(): void {
    localStorage.removeItem(this.tokenStorageKey);
    localStorage.removeItem(this.userStorageKey);
  }

  getUser(): User | null{
    const user = localStorage.getItem(this.userStorageKey);

    if (!user) {
      return null;
    }

    try {
      return JSON.parse(user) as User;
    } catch {
      return null;
    }
  }

  private getToken(): string {
    return localStorage.getItem(this.tokenStorageKey)?.trim() ?? '';
  }

  // public hasRole(roleString: string): boolean{
  //   // @ts-ignore
  //   return this.getUser().roles?.filter(role => (role.code === roleString)).length > 0;
  // }

  // public isActive(): boolean{
  //   return this.getUser().is_active ?? false;
  // }

}
